import { render, staticRenderFns } from "./PatientTableItem.vue?vue&type=template&id=adaccf06&scoped=true"
import script from "./PatientTableItem.vue?vue&type=script&lang=js"
export * from "./PatientTableItem.vue?vue&type=script&lang=js"
import style0 from "./PatientTableItem.vue?vue&type=style&index=0&id=adaccf06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adaccf06",
  null
  
)

export default component.exports